module.exports = __webpack_public_path__ + "static/media/washer.409bfebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/record/img/washer.png
// module id = 348
// module chunks = 0